export type KycStatus =
  | 'APPROVED'
  | 'REJECTED_MANUAL'
  | 'REQUESTED_MANUAL'
  | 'UPLOADED_MANUAL'
  | 'REQUESTED_PARTNER';

export const KYC_STATUS = {
  APPROVED: 'APPROVED',
  REJECTED_MANUAL: 'REJECTED_MANUAL',
  REQUESTED_MANUAL: 'REQUESTED_MANUAL',
  UPLOADED_MANUAL: 'UPLOADED_MANUAL',
} as const;

export type ComplianceStatus =
  | 'NORMAL'
  | 'FULLY_BLOCKED'
  | 'BLOCKED'
  | 'WARNING'
  | 'UNDER_COMPLIANCE_REVIEW'
  | 'UNDER_COMPLIANCE_REVIEW_2'
  | 'REVISION'
  | 'CUSTOMER_REVIEW'
  | 'PENDING_COMPLIANCE';

export const COMPLIANCE_STATUS = {
  NORMAL: 'NORMAL',
  FULLY_BLOCKED: 'FULLY_BLOCKED',
  BLOCKED: 'BLOCKED',
  WARNING: 'WARNING',
  UNDER_COMPLIANCE_REVIEW: 'UNDER_COMPLIANCE_REVIEW',
  UNDER_COMPLIANCE_REVIEW_2: 'UNDER_COMPLIANCE_REVIEW_2',
  REVISION: 'REVISION',
  CUSTOMER_REVIEW: 'CUSTOMER_REVIEW',
  PENDING_COMPLIANCE: 'PENDING_COMPLIANCE',
} as const;

type KycAddressCountryType = {
  id?: number;
  country: string;
  state: string;
  city: string;
  street: string;
  number: string;
  complementAddress: string;
  routeId: number;
};

export interface KycUser {
  name: string | null;
  lastName: string | null;
  email: string;
  identificationType: string | null;
  identificationNumber: string | null;
  phoneCountryCode: string | null;
  phoneNumber: string | null;
  createAt: string;
  kycStage1: string;
  hasPin: boolean;
  verifiedPhone: boolean;
  level: number;
}

type KycUserType = {
  name: string;
  lastName: string;
  sex: string;
  identificationType: string;
  identificationNumber: string;
  nationality: string;
  phoneCountryCode: string;
  phoneNumber: string;
  politicallyExposedPerson: boolean;
  addressCountry: KycAddressCountryType;
  kycStage1: KycStatus;
  id?: number;
  email?: string;
  createAt: string;
  hasPin: boolean;
  verifiedPhone: boolean;
  level: number;
  multiUserEnabled: boolean;
  isLegalRepresentative: boolean;
  birthDate: string;
};

type KycCompanyType = {
  id: string;
  name: string;
  identificationType: string;
  identificationNumber: string;
  institutional: boolean;
  phoneCountryCode: string;
  phoneNumber: string;
  activity: string;
  estimatedAnnualBillings: string;
  shipmentAmounts: string;
  shipmentFrequency: string;
  addressCountry: KycAddressCountryType;
  kycStage1: KycStatus;
  kycStage1Comment: string;
  complianceStatus: ComplianceStatus;
  termsAndConditions: boolean;
  username: string;
  createAt: string;
  kycStage1ApprovedDate: string;
  hasBeneficiaryFile: boolean;
  /**
   * `true` si la empresa tiene al menos un propósito activo con id distinto de 1
   * (Libre Canalización); `false` en cualquier otro caso. Su ausencia se trata fail-closed.
   */
  isComex?: boolean;
};

type KycCompliance = {
  b2bUser: KycUserType;
  company: KycCompanyType;
};

export { KycCompanyType, KycAddressCountryType, KycCompliance, KycUserType };
